// extracted by mini-css-extract-plugin
export default {"table":"DataTop_table__8o5W5"};